import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type TreatmentSummary } from 'api/apertureAPI';

export interface TreatmentSearchParams {
    memberId?: string;
    memberFirstName?: string;
    memberLastName?: string;
    memberDob?: string;
    groupId?: string;
}

export interface TreatmentListSliceState {
    lastSearchParams: TreatmentSearchParams;
    searchResults: { treatments?: TreatmentSummary[]; restrictedGroup?: boolean };
}

const initialState: TreatmentListSliceState = {
    lastSearchParams: {},
    searchResults: { treatments: undefined, restrictedGroup: undefined },
};

export const treatmentListSlice = createSlice({
    name: 'treatmentList',
    initialState,
    reducers: {
        setTreatmentSearchData(
            state,
            action: PayloadAction<{
                searchParams: TreatmentSearchParams;
                searchResults: { treatments: TreatmentSummary[] };
            }>,
        ) {
            const { searchParams, searchResults } = action.payload;
            return { ...state, lastSearchParams: searchParams, searchResults };
        },
        setRestrictedGroup(state, action: PayloadAction<{ restrictedGroup: boolean }>) {
            const { restrictedGroup } = action.payload;
            return { ...state, searchResults: { ...state.searchResults, restrictedGroup } };
        },
        resetTreatmentSearchData(state) {
            const { lastSearchParams, searchResults } = initialState;
            return { ...state, lastSearchParams, searchResults };
        },
    },
});

export const { setTreatmentSearchData, setRestrictedGroup, resetTreatmentSearchData } =
    treatmentListSlice.actions;
